const data = {
    voicedConsonants: ['б', 'в', 'г', 'д', 'ж', 'з', 'й', 'л', 'м', 'н', 'р'],
    deafConsonants: ['к', 'с', 'п', 'т', 'ф', 'х', 'ц', 'ч', 'ш', 'щ'],
    voicedPairedHardConsonants: [
        'ба',
        'бо',
        'бу',
        'бы',
        'бэ',
        'да',
        'до',
        'ду',
        'ды',
        'дэ',
        'га',
        'го',
        'гу',
        'гы',
        'гэ',
        'ва',
        'во',
        'ву',
        'вы',
        'вэ',
        'за',
        'зо',
        'зу',
        'зы',
        'зэ',
        'жа',
        'жо',
        'жу',
        'же',
        'жё',
        'жи',
        'жю',
    ],
    voicedPairedSoftConsonants: [
        'бя',
        'бе',
        'бё',
        'бю',
        'би',
        'дя',
        'де',
        'дё',
        'дю',
        'ди',
        'гя',
        'ге',
        'гё',
        'гю',
        'ги',
        'вя',
        'ве',
        'вё',
        'вю',
        'ви',
        'зя',
        'зе',
        'зё',
        'зю',
        'зи',
    ],
    voicedSoftUnpairedConsonants: [
        'ля',
        'ле',
        'лё',
        'лю',
        'ли',
        'мя',
        'ме',
        'мё',
        'мю',
        'ми',
        'ня',
        'не',
        'нё',
        'ню',
        'ни',
        'ря',
        'ре',
        'рё',
        'рю',
        'ри',
    ],
    voicedHardUnpairedConsonants: [
        'ла',
        'ло',
        'лу',
        'лы',
        'лэ',
        'ма',
        'мо',
        'му',
        'мы',
        'мэ',
        'на',
        'но',
        'ну',
        'ны',
        'нэ',
        'ра',
        'ро',
        'ру',
        'ры',
        'рэ',
    ],
    deafPairedHardConsonants: [
        'па',
        'по',
        'пу',
        'пы',
        'пэ',
        'та',
        'то',
        'ту',
        'ты',
        'тэ',
        'ка',
        'ко',
        'ку',
        'кы',
        'кэ',
        'фа',
        'фо',
        'фу',
        'фы',
        'фэ',
        'са',
        'со',
        'су',
        'сы',
        'сэ',
        'ха',
        'хо',
        'ху',
        'хы',
        'хэ',
        'ша',
        'шо',
        'шу',
        'ше',
        'шё',
        'ши',
        'шю',
    ],
    deafPairedSoftConsonants: [
        'пя',
        'пе',
        'пё',
        'пю',
        'пи',
        'тя',
        'те',
        'тё',
        'тю',
        'ти',
        'кя',
        'ке',
        'кё',
        'кю',
        'ки',
        'фя',
        'фе',
        'фё',
        'фю',
        'фи',
        'ся',
        'се',
        'сё',
        'сю',
        'си',
        'хя',
        'хе',
        'хё',
        'хю',
        'хи',
    ],
    deafUnpairedHardConsonants: ['ца', 'цо', 'цу', 'цы', 'ци', 'це'],
    deafUnpairedSoftConsonants: ['ча', 'чо', 'чу', 'чи', 'че', 'чё', 'чь', 'ща', 'що', 'щу', 'ще', 'щё', 'щи', 'щь'],
    consonants: [
        'б',
        'в',
        'г',
        'д',
        'ж',
        'з',
        'й',
        'к',
        'л',
        'м',
        'н',
        'п',
        'р',
        'с',
        'т',
        'ф',
        'х',
        'ц',
        'ч',
        'ш',
        'щ',
    ],
    vowels: ['а', 'о', 'у', 'ы', 'э', 'я', 'ю', 'ё', 'и', 'е'],
};

export default data;
